export default __webpack_public_path__ + "static/englet-9-57555d347a04528575f8df98484fa21f.jpg";